module.exports = __webpack_public_path__ + "media/images/checkout/discover-a3ac4886d08523d687cd7ab464c7c177.png";